<template>
  <label class="checkbox">
    <input type="checkbox" v-model="modelValue">
    <span class="box"></span>
    <slot></slot>
  </label>
</template>

<script>
export default {
  props: ['value'],
  computed: {
    modelValue: {
      set(newVal) {
        this.$emit('input', newVal);
      },
      get() {
        return this.value;
      },
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../assets/variables";

.checkbox {
  cursor: pointer;
  display: flex;
  align-items: center;
}

input {
  display: none;

  &:checked + .box:before {
    content: '';
    display: block;
    width: 9px;
    height: 9px;
    background-color: $primary;
    border-radius: 1px;
  }
}

.box {
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 20px;
  height: 20px;
  border: 1px solid $primary;
  margin-right: 7px;
  border-radius: 3px;
}
</style>
